import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-demo-alerts',
  templateUrl: './demo-alerts.component.html',
  styleUrls: ['./demo-alerts.component.less']
})
export class DemoAlertsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
